import intl from 'react-intl-universal'
/* global Notification alert, localStorage */

let permission =
  typeof Notification === 'function' ? Notification.permission : 'notSupported'
const icon = 'https://s3.amazonaws.com/arc-components/dashboard/ellipsis.png'
const defaultTitle = 'Arc - Ellipsis'
const optOutKey = 'optOutOfNotifications'

/**
  @function isOptOut
  Determines if user opted out of notifications when they got the initial prompt.
  @returns {Boolean}
*/
const isOptOut = () => !!localStorage.getItem(optOutKey)

/**
  @function notificationsEnabled
  Determines is user previously approved notifications
  @returns {Boolean}
*/
const notificationsEnabled = () => permission === 'granted'

/**
  @function notifcationsNeedApproval
  Determines is user has not approeved or denied notifications
  @returns {Boolean}
*/
const notifcationsNeedApproval = () => permission === 'default'

/**
  @function spawnNotification
  @param {String} body - The body text of the notification message
  @param {String} [title='Arc - Ellipsis]' - The title text of the notifcation message
  @returns {Promise} The promise returned from Notification api
*/
const spawnNotification = (body, title = defaultTitle) => {
  const options = {
    body,
    icon,
  }
  return new Notification(title, options)
}

/**
  @function notificationSeekPermission
  Triggers the browser's request to enable notifcations
  @returns {promise} Promise returns the notification state after user makes decision
*/
export const notificationSeekPermission = () => {
  return Notification.requestPermission().then((permissionState) => {
    if (permissionState === 'granted') {
      notificationSend(intl.get('notificationSeekPermission.notificationSend'))
    } else {
      alert(intl.get('notificationSeekPermission.alert'))
    }
    permission = permissionState
    return getNotificationState()
  })
}

/**
  @function getNotificationState
  Get the status of the notification state returns object saying if it is enabled, disabled, or needs approval
  @returns {Object} Object that contains the approval/enbaled state of notifcations.
*/
export const getNotificationState = () => ({
  needsApproval: notifcationsNeedApproval() && !isOptOut(),
  isEnabled: notificationsEnabled(),
  isDenied: !notifcationsNeedApproval() && !notificationsEnabled(),
  isOptOut: isOptOut(),
})

/**
  @function notificationSend
  Show a message to the user that pops out of the browser
  @param {string} message - The body text of the message
  @param {string} [title] - The title of the message
*/
export const notificationSend = (message, title) => {
  if (notificationsEnabled) {
    spawnNotification(message, title)
  }
}

/**
 @function optOutOfRequests
 Allows a user to disable the request for notifications.
 Sets localstorage to say they turned it down.
**/
export const optOutOfRequests = () => {
  localStorage.setItem(optOutKey, 'true')
}

/**
 @function removeOptOutRequest
 Allows a user to enabled the request for notifications.
 Removes localstorage value so notifcations can be requested again.
**/
export const removeOptOutRequest = () => {
  localStorage.removeItem(optOutKey, 'true')
}
